/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ExpectedSourcingProcess } from './';
import {
    ExpectedSourcingProcessFromJSON,
    ExpectedSourcingProcessFromJSONTyped,
    ExpectedSourcingProcessToJSON,
} from './';
import type { UpdatedField } from './';
import {
    UpdatedFieldFromJSON,
    UpdatedFieldFromJSONTyped,
    UpdatedFieldToJSON,
} from './';
import type { UpdatedFieldName } from './';
import {
    UpdatedFieldNameFromJSON,
    UpdatedFieldNameFromJSONTyped,
    UpdatedFieldNameToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExpectedSourcingProcessField
 */
export interface ExpectedSourcingProcessField extends UpdatedField {
    /**
     * 
     * @type {ExpectedSourcingProcess}
     * @memberof ExpectedSourcingProcessField
     */
    value: ExpectedSourcingProcess;
}

/**
 * Check if a given object implements the ExpectedSourcingProcessField interface.
 */
export function instanceOfExpectedSourcingProcessField(value: object): value is ExpectedSourcingProcessField {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function ExpectedSourcingProcessFieldFromJSON(json: any): ExpectedSourcingProcessField {
    return ExpectedSourcingProcessFieldFromJSONTyped(json, false);
}

export function ExpectedSourcingProcessFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpectedSourcingProcessField {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldFromJSONTyped(json, ignoreDiscriminator),
        'value': ExpectedSourcingProcessFromJSON(json['value']),
    };
}

export function ExpectedSourcingProcessFieldToJSON(value?: ExpectedSourcingProcessField | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldToJSON(value, true),
        'value': ExpectedSourcingProcessToJSON(value['value']),
    };
}

